import React, {FC, useEffect} from "react";
import {CodeFieldProps} from "./CodeField.types";
import styles from "./CodeField.module.scss";
import {TextField} from "../index";

const CodeField: FC<CodeFieldProps> = ({digits, onChange, error, placeholder}) => {
    const refs = Array.from({length: digits}, () => React.createRef<HTMLInputElement & HTMLTextAreaElement>());
    const [numbers, setNumbers] = React.useState<("" | number)[]>(Array.from({length: digits}, () => ""));

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
        const value = e.target.value;

        if(value.length > 1) {
            if (index !== digits - 1) {
                refs[index + 1].current.focus();
            }
            return;
        }

        if (value.length === 1) {
            if (index !== digits - 1) {
                refs[index + 1].current.focus();
            }
        }
        setNumbers((prevNumbers) => {
                const newNumbers = [...prevNumbers];
                newNumbers[index] = value === "" ? value : parseInt(value, 10);
                return newNumbers;
            }
        );
    }

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
        if (e.key === 'Backspace' && index > 0) {
            if(numbers[index] === "") {
                e.preventDefault();
                refs[index - 1].current.focus();
            }
        }
    }

    useEffect(() => {
        if (onChange) {
            onChange(numbers.join(""));
        }
    } , [numbers]);

    return (
        <div className={styles.CodeField} data-testid="CodeField">
            {
                refs.map((ref, i) => (
                    <TextField
                        key={i}
                        type={"number"}
                        maxLength={1}
                        minLength={1}
                        min={0}
                        max={9}
                        ref={ref}
                        placeholder={placeholder}
                        value={numbers[i]}
                        className={styles.TextField}
                        error={error}
                        pattern={"[0-9]*"}
                        onChange={(event) => {
                            handleChange(event, i)
                        }}
                        onKeyDown={(event) => {
                            onKeyDown(event, i)
                        }}
                    />
                ))
            }
        </div>
    );
};

export default CodeField;
